var _path, _circle, _circle2, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 85,
    viewBox: "0 0 60 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 46.5685 38.75 76.25 30 85C21.25 76.25 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z",
    fill: "url(#paint0_linear_67_8363)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25,
    fill: "url(#paint1_linear_67_8363)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 23,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0088 42.3942H18.8501C18.4323 42.3942 18.0286 42.1753 17.7984 41.8257C17.5824 41.4988 17.5454 41.1038 17.6989 40.7371C17.7615 40.5893 17.8212 40.4386 17.8808 40.288C18.0315 39.91 18.1878 39.5206 18.3811 39.1511C20.7545 34.6118 25.7655 32.247 30.8533 33.2645C32.1438 33.5232 33.3972 34.0149 34.574 34.7227C34.7218 34.8108 34.8866 34.8705 35.0287 34.8818C35.3954 34.9188 35.7194 34.6942 35.836 34.3304C35.9525 33.9638 35.8104 33.6028 35.4665 33.3896C33.6076 32.2441 31.5639 31.5932 29.3952 31.454C27.2435 31.3147 25.2169 31.6586 23.3666 32.4744C19.8307 34.0348 17.3976 36.6867 16.1385 40.3562C15.9623 40.8735 15.9537 41.4107 16.1157 41.9565C16.4767 43.173 17.5909 43.9916 18.887 43.9916C20.8141 43.9916 22.7413 43.9916 24.6712 43.9916H26.8968H32.5275C33.3717 43.9916 34.2187 43.9916 35.0628 43.9916C35.2959 43.9916 35.5063 43.9035 35.6597 43.7443C35.8104 43.5908 35.8871 43.3805 35.8814 43.1588C35.8672 42.7125 35.5034 42.3885 35.0202 42.3885L35.0088 42.3942Z",
    fill: "#2C2C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5399 29.7854H28.5484C30.3818 29.7854 32.1071 29.0691 33.4089 27.7702C34.7107 26.4684 35.4298 24.7402 35.4326 22.9012C35.4326 21.0594 34.7192 19.3255 33.4174 18.0209C32.1156 16.7191 30.3874 16 28.5456 16C24.7539 16 21.6614 19.0868 21.6501 22.8813C21.6444 24.7118 22.3578 26.44 23.6596 27.7474C24.9671 29.0606 26.7009 29.7826 28.5428 29.7854H28.5399ZM28.5399 17.6031H28.5484C31.4619 17.6088 33.8295 19.9821 33.8295 22.8927C33.8295 25.8061 31.459 28.1795 28.5456 28.1795C27.133 28.1795 25.8027 27.6252 24.7994 26.6219C23.7989 25.6185 23.2503 24.2911 23.2531 22.8813C23.2617 19.9679 25.6322 17.6031 28.5428 17.6031H28.5399Z",
    fill: "#2C2C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1921 38.3353C42.527 38.3297 41.8647 38.3297 41.1996 38.3325H39.9319V37.1245C39.9319 36.4452 39.9319 35.7659 39.9319 35.0865C39.9319 34.7568 39.7898 34.5209 39.5056 34.3674C39.2554 34.2338 38.9627 34.2395 38.7239 34.3816C38.4795 34.5266 38.3345 34.7852 38.3317 35.078C38.326 35.746 38.3288 36.4139 38.3317 37.0847V38.3353H37.2317C36.5325 38.3353 35.8304 38.3353 35.1312 38.341C34.9834 38.341 34.8327 38.3751 34.7133 38.4291C34.3893 38.5769 34.2131 38.9464 34.2927 39.3103C34.3751 39.6769 34.6906 39.9356 35.063 39.9384C35.7423 39.9413 36.4216 39.9413 37.1009 39.9384H37.9167H38.3317V41.1834C38.3317 41.8542 38.3317 42.5221 38.3317 43.1929C38.3317 43.642 38.6813 43.9945 39.1218 44.0001H39.1304C39.5738 44.0001 39.9262 43.6505 39.9347 43.2014C39.9376 42.9314 39.9376 42.6586 39.9347 42.3885V39.9384H43.1608C43.4308 39.9384 43.6383 39.8475 43.7947 39.6599C44.0192 39.3898 44.059 39.1113 43.9169 38.8043C43.7748 38.4974 43.5303 38.3382 43.1921 38.3353Z",
    fill: "#2C2C2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_8363",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A97F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_67_8363",
    x1: 30,
    y1: 5,
    x2: 30,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A97F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D3FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserIcon);
export default __webpack_public_path__ + "static/media/addUserIcon.2afaae660ab2fb8971f8800e0d94071f.svg";
export { ForwardRef as ReactComponent };